export default __webpack_public_path__ + "static/media/detail_mobile_12_6.74923656.jpg";